import React from "react";
import { COLOR_WHITE } from "../../constants/styles";
import { Table } from "../../UI/Table";
import { Typography } from "../../UI/Typography";
import { HelpTooltip, TooltipURL } from "../HelpTooltip";

import { TableHeader } from "../TableHeader";
import { Grid } from "../../UI/Grid";
import { ExternalLink } from "../../common/component/NavLink";

export interface IProps {
  title?: string;
  className?: string;
  titleEndAdorment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  titleHelpTooltip?: string;
  urlHelpTooltip?: TooltipURL;
}

export const EnhancedTable: React.FC<IProps> = (props) => {
  const customTooltipText = <>
     <Grid item xs={12}>
      <Typography color={COLOR_WHITE} sx={{ fontSize: "14px !important" }}>
        {props.titleHelpTooltip}
      </Typography>
    </Grid>
    {props.urlHelpTooltip && (
      <Grid item xs={12} mt={2}>
      <Typography color={COLOR_WHITE} sx={{ fontSize: "14px !important" }}>
        <ExternalLink name={props.urlHelpTooltip.text} to={props.urlHelpTooltip.link} />
      </Typography>
    </Grid>
    )}
  </>;

  return (
    <>
      {props.title && (
        <TableHeader endAdornment={props.endAdornment}>
          <Grid container alignItems="center" spacing={2}>
            {props.title && !props.titleHelpTooltip && (
              <Grid item>
                <Typography fontWeight={600} color={COLOR_WHITE}>
                  {props.title}
                </Typography>
              </Grid>
            )}
            {props.title && props.titleHelpTooltip && (
              <Grid item>
                <HelpTooltip color="white" title={props.title} customText={customTooltipText}>
                  <Typography fontWeight={600} color={COLOR_WHITE}>
                    {props.title}
                  </Typography>
                </HelpTooltip>
              </Grid>
            )}
            {props.titleEndAdorment && <Grid item>{props.titleEndAdorment}</Grid>}
          </Grid>
        </TableHeader>
      )}
      <Table padding="checkbox">{props.children}</Table>
    </>
  );  
};